module.exports = __webpack_public_path__ + "assets/videos/covid-hits-home-poster-image.jpg?v=1ebeac3e";